<template>
  <section class="white-gradient">
    <v-container fluid style="padding-bottom:64px">
      <v-row justify="center" class="info-tiles">
        <v-col
          cols="10"
          sm="10"
          md="4"
          lg="4"
          xl="3"
          :class="`${tile.sidebars ? 'desktop-sidebars' : ''}`"
          v-for="(tile,t) in tiles"
          :key="t"
        >
          <v-container class="pa-0 d-block d-md-none" id="home-header-mobile">
            <v-row>
              <v-col cols="4">
                <div class="text-center">
                  <v-img :src="tile.logo" style="width:100%;height:auto"></v-img>
                </div>
              </v-col>
              <v-col cols="8">
                <h5 class="secondary--text tile-title">{{tile.title}}</h5>
                <p class="caption mt-2" v-html="tile.description"></p>
                <div class="mt-4" v-if="tile.link.url">
                  <v-btn
                    small
                    v-if="tile.link.url.startsWith('http')"
                    :href="tile.link.url"
                    color="secondary"
                  >{{tile.link.text}}</v-btn>
                  <v-btn small v-else :to="tile.link.url" color="secondary">{{tile.link.text}}</v-btn>
                </div>
                <div class="mt-4" v-else>
                  <v-btn small outlined disabled>{{tile.link.text}}</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="pa-0 d-none d-md-block" id="home-header-desktop">
            <v-row justify="center">
              <v-col cols="10" lg="8" xl="9" class="text-center">
                <v-img :src="tile.logo" style="width:100%;height:auto"></v-img>
              </v-col>
              <v-col cols="11" class="text-center">
                <h3 class="secondary--text tile-title">{{tile.title}}</h3>
                <p class="info-tile-text" v-html="tile.description"></p>
              </v-col>
              <v-col cols="11" class="text-center">
                <div v-if="tile.link.url">
                  <v-btn
                    v-if="tile.link.url.startsWith('http')"
                    :href="tile.link.url"
                    color="secondary"
                  >{{tile.link.text}}</v-btn>
                  <v-btn v-else :to="tile.link.url" color="secondary">{{tile.link.text}}</v-btn>
                </div>
                <div v-else>
                  <v-btn outlined disabled>{{tile.link.text}}</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Header",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    tiles() {
      return this.value.tiles;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-tiles a {
  text-decoration: none;
}
.tile-title {
  font-family: "Montserrat", sans-serif;
}
.info-tiles {
  padding-top: 64px;
  @media only screen and (max-width: 959px) {
  }
}
.info-tile-text {
  padding-top: 16px;
  min-height: 130px;
}
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 160px;
  letter-spacing: -6px;
}
.desktop-sidebars {
  border-left: 1px solid rgba(0, 0, 0, 0.15);
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}

@media only screen and (max-width: 959px) {
  .info-tile-text {
    padding-top: 16px;
    min-height: 125px;
  }
  .info-tile {
    margin-bottom: 64px;
  }
  .desktop-sidebars {
    border-left: none;
    border-right: none;
  }
  .logofont {
    font-size: 100px;
  }
}
@media only screen and (max-width: 375px) {
  .info-tile-text {
    padding-top: 16px;
    min-height: 0px;
    font-size: 12px;
  }
  .info-tiles {
    padding-top: 16px;
  }
  .info-tile {
    margin-bottom: 32px;
  }
  .logofont {
    font-size: 80px;
  }
}
</style>